import TemplatesAnnouncementModal from './TemplatesAnnouncementModal.container'

export default TemplatesAnnouncementModal
